module.exports = __webpack_public_path__ + "static/media/gLS.035c544e.svg";